@if (store.goalsEnabled()) {
  <div class="bn-goals-bar flex items-center justify-between gap-3 flex-wrap">
    <div class="bn-goals-bar__pills flex items-center gap-2 flex-wrap">
      <span class="bn-goals-bar__label">
        Goals {{ store.activeGoals().length }}/{{ maxActiveGoals }}
      </span>

      @if (store.activeGoals().length === 0) {
        <span class="bn-goals-bar__empty text-sm text-surface-500"
          >No active goals</span
        >
      } @else {
        @for (goal of store.activeGoals(); track goal.id) {
          <span class="bn-goals-bar__pill" [title]="goal.displayText">
            {{ goal.displayText }}
            <span class="bn-goals-bar__pill-count">{{
              linkedCaseCount(goal.id)
            }}</span>
          </span>
        }
      }
    </div>

    <button
      type="button"
      class="bn-goals-bar__manage"
      [disabled]="!store.canManageGoals()"
      (click)="manageGoals.emit()"
    >
      Manage goals
    </button>
  </div>
}
